import { createToaster } from "./toast-parts";
import { AromaPlacement, TOAST_ICON, ToastShowOptions } from "./types";

const commonToastOptions = {
  pauseOnPageIdle: true,
  pauseOnHover: true,
  overlap: true,
  gap: 14,
};

const toasterBottomEnd = createToaster({
  placement: "bottom-end",
  ...commonToastOptions,
});

const toasterBottomStart = createToaster({
  placement: "bottom-start",
  ...commonToastOptions,
});

const toasterBottom = createToaster({
  placement: "bottom",
  ...commonToastOptions,
});

const toasterTopEnd = createToaster({
  placement: "top-end",
  ...commonToastOptions,
});

const toasterTopStart = createToaster({
  placement: "top-start",
  ...commonToastOptions,
});

const toasterTop = createToaster({
  placement: "top",
  ...commonToastOptions,
});

export const toasters = {
  [AromaPlacement.BottomRight]: toasterBottomEnd,
  [AromaPlacement.BottomLeft]: toasterBottomStart,
  [AromaPlacement.BottomCenter]: toasterBottom,
  [AromaPlacement.TopRight]: toasterTopEnd,
  [AromaPlacement.TopLeft]: toasterTopStart,
  [AromaPlacement.TopCenter]: toasterTop,
};

export const showToast = ({
  title,
  action,
  iconName,
  description,
  duration = 6000,
  type = "neutral",
  placement = AromaPlacement.BottomRight,
}: ToastShowOptions) => {
  const aromaPlacement = placement ?? AromaPlacement.BottomRight;
  const toaster = toasters[aromaPlacement];

  if (toaster) {
    const icon = iconName ?? TOAST_ICON[type];

    toaster.machine.setContext({
      duration,
    });

    toaster.create({
      type,
      title,
      description,
      action,
      meta: { icon },
    });
  }
};
